// Relative "how soon" labels for upcoming events — drives the countdown
// badges on the events calendar, teasers and event guide pages.

export function daysUntil(startISO) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
  const start = new Date(startISO + "T12:00:00");
  return Math.round((start - today) / 86400000);
}

// NOTE: every literal this returns must exist in scripts/i18n-source.json so
// the runtime translation engine can localize the badge text.
export function countdownLabel(startISO) {
  const days = daysUntil(startISO);
  if (days <= 0) return "Today";
  if (days === 1) return "Tomorrow";
  if (days <= 6) return "This week";
  if (days <= 13) return "Next week";
  const weeks = Math.round(days / 7);
  if (weeks <= 8) return `In ${weeks} weeks`;
  return `In ${Math.round(days / 30.44)} months`;
}

// Urgency tier for badge styling: near (≤ 3 weeks) / mid (≤ ~2 months) / far.
export function countdownTier(startISO) {
  const days = daysUntil(startISO);
  if (days <= 21) return "near";
  if (days <= 62) return "mid";
  return "far";
}
